<template>
    <v-dialog v-model="removeModal" max-width="400">
        <v-card>
            <v-card-title class="primary white--text" :class="{
                'headline': !isMobilePort,
                'caption mobile-title': isMobilePort
            }">
                Delete Note / Bookmark
                <v-spacer></v-spacer>
                <v-icon class="primary white--text" @click="removeModal = false">close</v-icon>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col class="text-center">
                        <p v-if="isEnterpriseAdminAction()" class="mb-0 mt-5">
                            Are you sure you want to delete this public note from {{ getNoteCreatorName() }}? It will be
                            removed for everyone in your Enterprise.
                        </p>
                        <p v-else class="mb-0 mt-5">
                            Are you sure you want to remove this note?
                        </p>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="removeModal = false">Cancel</v-btn>
                <v-btn color="error" :loading="isDeleting" @click="deleteNote">Delete</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>

import { EventNames } from '../../../classes/EventNames';
import { NotesPageApi } from '../../../api/NotesPageApi';
import Mobile from '../../inc/mixins/mobile';
import {showNotification} from "../../../global";

export default {
    data() {
        return {
            removeModal: false,
            note: {},
            isDeleting: false,
        }
    },
    mixins: [Mobile],
    computed: {
        currentUserId() {
            return parseInt(this.$store?.getters?.getUserId);
        }
    },
    methods: {
        async deleteNote() {
            this.isDeleting = true;
            const isAnnotation = this.isAnnotation();
            const deleteFn = isAnnotation ? NotesPageApi.deleteAnnotation : NotesPageApi.deleteBookmark;
            const noteType = isAnnotation ? 'annotation' : 'bookmark';

            try {
                await deleteFn(this.note.id);
                EventBus.fire(EventNames.UPDATE_NOTES, {
                    action: 'remove',
                    type: noteType,
                    id: this.note.id,
                    sectionId: this.note.sectionId || this.note.sectionID
                });
                this.removeModal = false;
                showNotification('Note deleted successfully', 'success');
            } catch (error) {
                console.error(`Failed to remove ${noteType}:`, error);
                showNotification('Error deleting note. Please refresh and try again.', 'error');
            } finally {
                this.isDeleting = false;
            }
        },

        onNoteDelete(data) {
            this.note = data;
            this.removeModal = true;
        },

        isAnnotation() {
            return Boolean(this.note?.annotation);
        },

        isEnterpriseBookmark() {
            return Boolean(this.note?.enterprise);
        },

        getBookmarkCreatorId() {
            const user = this.note.user;
            return user && user.id ? parseInt(user.id) : (user !== undefined ? parseInt(user) : 0);
        },

        isEnterpriseAdminAction() {
            return this.isEnterpriseBookmark() &&
                this.currentUserId !== this.getBookmarkCreatorId();
        },
        getNoteCreatorName() {
            return this.note?.userName;
        }
    },
    created() {
        EventBus.listen(EventNames.REMOVE_BOOKMARK, this.onNoteDelete);
        EventBus.listen(EventNames.REMOVE_NOTE, this.onNoteDelete);
    },
    beforeDestroy() {
        EventBus.off(EventNames.REMOVE_BOOKMARK, this.onNoteDelete);
        EventBus.off(EventNames.REMOVE_NOTE, this.onNoteDelete);
    }

}
</script>